import { PaymentProviderEvent } from './payment-provider.event';

/**
 * Represents the state when payment provider performs an busy work
 */
export class WorkPaymentProviderEvent extends PaymentProviderEvent {}
